import axios from 'axios';
 
class PlanService { 
  getPlans() { 
    return axios.get(`plan`); 
  } 
  getVerifyPlan(type) {  
    return axios.get(`plan/verify?type=${type}`); 
  } 
  getCurrentPlanByCompany() {  
    return axios.get(`plan/current-plan`); 
  } 
}

export default new PlanService();